import type { Dispatch } from "react";

import { EditableLabel } from "@/features/widget-forms/forms/weather-model-map/components/editable-label";
import DraggableCard, {
  configItemCardStyles,
} from "@/features/widget-forms/forms/weather-model-map/components/draggable-card/draggable-card";
import type { ParameterTimeSeriesConfigurationSeriesInner as ParameterTimeSeriesSeries } from "@/lib/api";
import type { TimeSeriesParameterOption } from "@/features/shared/widgets/map/time-series/time-series-parameter.types";
import { resolveParameterUnitSymbol } from "@/features/shared/widgets/map/time-series/time-series-parameter-option.utils";
import { useTranslation } from "@/lib/i18n";

import styles from "./time-series-series-card.module.css";

interface TimeSeriesSeriesCardProps {
  series: ParameterTimeSeriesSeries;
  parameter: TimeSeriesParameterOption | undefined;
  unitCode: string | undefined;
  onRemove: () => void;
  onLabelChange: Dispatch<string>;
}

function TimeSeriesSeriesCard({
  series,
  parameter,
  unitCode,
  onRemove,
  onLabelChange,
}: TimeSeriesSeriesCardProps) {
  const { t } = useTranslation();
  const catalogLabel = parameter?.label ?? series.parameter_id;
  const unitSymbol = parameter ? resolveParameterUnitSymbol(parameter, unitCode) : "";

  return (
    <DraggableCard
      onRemove={onRemove}
      removeLabel={t("admin.widgets.fields.model_map.general.remove_item", {
        item: series.label || catalogLabel,
      })}
    >
      <div className={configItemCardStyles.titleGroup}>
        <div className={configItemCardStyles.title}>
          <EditableLabel
            value={series.label}
            onValueChange={onLabelChange}
            placeholder={catalogLabel}
          />
        </div>
        <div className={styles.parameterMeta}>
          <span className={styles.catalogLabel}>{catalogLabel}</span>
          {parameter?.datasetLabel && (
            <>
              <span className={styles.separator}>·</span>
              <span className={styles.datasetLabel}>{parameter.datasetLabel}</span>
            </>
          )}
          {unitSymbol && (
            <>
              <span className={styles.separator}>·</span>
              <span className={styles.unitPill}>{unitSymbol}</span>
            </>
          )}
        </div>
      </div>
    </DraggableCard>
  );
}

export default TimeSeriesSeriesCard;
